import { createSlice } from '@reduxjs/toolkit';

export const settingsSlice = createSlice({
  name: 'settingsSlice',
  initialState: {
    shop: {
      listView: 'grid',
    },
  },
  reducers: {
    settingsStoreSlice: (state, action) => {
      state.shop = { listView: action.payload.shop?.listView ?? 'grid' };
    },
    settingsUpdateShop: (state, action) => {
      state.shop = action.payload;
    },
  },
});

export const { settingsStoreSlice, settingsUpdateShop } = settingsSlice.actions;

export const selectSettingsShop = (state) => state.settingsSlice.shop;

export default settingsSlice.reducer;
